import { useBulkTakedownNotifier } from '../../hooks/useBulkTakedownNotifier';

/** Headless app-wide listener that turns failed bulk-takedown items into
 * notification-drawer entries, so failures aren't lost when the progress
 * modal is closed. See useBulkTakedownNotifier. */
const BulkTakedownNotifier = () => {
  useBulkTakedownNotifier();
  return null;
};

export default BulkTakedownNotifier;
